<template>
  <!-- <v-autocomplete
    v-model="model"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    chips
    clearable
    hide-details
    hide-selected
    :item-text="itemText"
    item-value="symbol"
    :label="label"
    solo
    filled
    return-object
    @click:close="remove(data.item)"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Search
          <strong>{{label}}</strong>
        </v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:selection="{ attr, on, item, selected }">
      <v-chip
        v-bind="attr"
        :input-value="selected"
        color="blue-grey"
        class="white--text"
        v-on="on"
      >
        <span v-text="item.name"></span>
      </v-chip>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-avatar
        color="indigo"
        class="headline font-weight-light white--text"
      >
        {{ item.name.charAt(0) }}
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="item.name"></v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete> -->
  <v-combobox
    v-model="model"
    :items="items"
    :item-text="itemText"
    :label="label"
    chips
    :solo='solo'
    :required='required'
    :rules='rules'
    :disabled='disabled'
  >
  <template v-slot:selection="data">
      <v-chip
        :key="JSON.stringify(data.item)"
        v-bind="data.attrs"
        :input-value="data.selected"
        :disabled="data.disabled"
      >
      <v-avatar
        class="accent white--text"
        left
        v-text="data.item.name.slice(0, 1).toUpperCase()"
      ></v-avatar>
        {{ data.item.name }}
      </v-chip>
  </template>
  </v-combobox>
</template>

<script>
import ApiService from '../common/api.service'
export default {
  name: 'AutoComplete',
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    search: null
  }),
  props: {
    default: null,
    label: null,
    itemText: null,
    url: null,
    field: null,
    type: null,
    solo: null,
    required: null,
    rules: null,
    disabled: null
  },
  mounted () {
    this.loadItems()
  },
  watch: {
    default: {
      immediate: true,
      handler (newVal, oldVal) {
        console.log(newVal, oldVal)
        if (this.default) {
          this.items.push(this.default)
          this.model = this.default
        }
      }
    },
    url: {
      immediate: true,
      handler (newVal, oldVal) {
        this.model = null
        this.loadItems()
      }
    },
    model (val) {
      if (val === '') {
        // Reset btn clicked from advance search
      } else if (val != null) {
        this.items.push(val)
        this.model = val
        let emitObject = val
        emitObject.__type = this.type
        emitObject.__field = this.field
        this.$emit('clicked', emitObject)
      } else {
        // this.items = []
        this.$emit('valueCleared')
      }
    },
    search (val) {
      console.log(this.items)
      // Items have already been loaded
      if (this.items.length > 0) return

      this.isLoading = true

      // Lazily load input items
      let slug = val.toLowerCase().trim().replace(/\s+/g, '-')
      let fetchUrl = this.url + slug
      ApiService.setHeader()
      ApiService.get(fetchUrl)
        .then(({ data }) => {
          this.items = data.results
          console.log(this.items)
        })
        .catch(({ response }) => {
          console.log(response)
        })
        .finally(() => (this.isLoading = false))
    }
  },
  methods: {
    remove (data) {
      alert('removed')
      this.items = []
    },
    loadItems () {
      if (this.url != null) {
        ApiService.setHeader()
        ApiService.get(`${this.url}&page_size=10000`)
          .then(({ data }) => {
            this.items = data.results
            this.model = this.default
            console.log(this.items)
          })
          .catch(({ response }) => {
            console.log(response)
          })
          .finally(() => (this.isLoading = false))
      }
    }
  }
}
</script>
